import * as yup from 'yup';
import { passwordRule, userIdRule } from './rules';

/**
 * One schema per form in the application.
 *
 * A form's shape is defined once, here, and both the initial values and the
 * validation come from it — which is what stops a field being added to the
 * markup and quietly never validated.
 */

export const loginSchema = yup.object({
  userId: userIdRule,
  password: passwordRule
});

export const changePasswordSchema = yup.object({
  currentPassword: passwordRule,
  newPassword: passwordRule
});

/**
 * Empty initial values derived from a schema's own field list.
 *
 * Every controlled input starts as '' rather than undefined — React warns and
 * then switches the input to uncontrolled the moment a value goes from
 * undefined to a string, which manifests as a field that stops accepting input.
 */
export function emptyValuesFor(schema) {
  return Object.fromEntries(Object.keys(schema.fields).map((field) => [field, '']));
}
